import Recipients from './recipients';

export default Recipients;
